export default __webpack_public_path__ + "static/158-min-min-151defdb671a045d967f8df3db49018b.jpg";